import { IAppState } from '../../common/state';

export function selectIsSeoCrossLinksV2Enabled({ featureToggle }: IAppState) {
  return featureToggle.isSeoCrossLinksV2Enabled;
}
